import EmailCampaign from "./EmailCampaign";

const EmailCampaignConfig = {
	settings: {},
	routes: [
		{
			path: '/email/campaigns',
			component: EmailCampaign
		}
	]
};

export default EmailCampaignConfig;
